import { useEffect, useState } from "react";
import { MdShoppingCart } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddToCart, setItemData } from "../Redux/Action";
import "./Body.css";

function Allapiproduct(props) {
  const allproductapi = useSelector((state) => state.ReducerAllProducts);
  const dispatch = useDispatch();
  const [proData, setProData] = useState();

  const increment = (item, index) => {
    if (item.qty < 10) {
      proData[index].qty += 1;
      const updatedData = [...proData];
      setProData(updatedData);
    }
  };
  const decrement = (item, index) => {
    if (item.qty > 1) {
      proData[index].qty -= 1;
      const updatedData = [...proData];
      setProData(updatedData);
    }
  };

  useEffect(() => {
    // const DEP = localStorage.getItem("MYData")

    if (allproductapi != "abc") {
      setProData(allproductapi);
      // localStorage.setItem("DEP",JSON.stringify(allproductapi))
    }
  }, [allproductapi]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div
        className="product-main-body"
        style={{ boder: "2px solid green", flexDirection: "row" }}
      >
        {proData ? (
          proData?.map((item, index) => {
            return (
              <div className="product_container1">
                {item.promoPercentage ? (
                  <span className="discount-offers">
                    {" "}
                    {item.promoPercentage}% OFF
                  </span>
                ) : (
                  ""
                )}
                <Link
                  to={"/productdetail"}
                  state={{ item }}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    console.warn("this is the object details" + item);
                    dispatch(setItemData(item));
                  }}
                >
                  <img
                    src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                  />
                </Link>

                <p className="P-product">{item.description}</p>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "-9px",
                  }}
                >
                  <span className="cr-price">
                    Rs.&nbsp;
                    {item?.promoPercentage
                      ? Math.round(
                          item?.unitRetail -
                            (item?.unitRetail * item?.promoPercentage) / 100
                        )
                      : item?.unitRetail}
                  </span>
                  {item?.promoPercentage > 0 ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.unitRetail}
                    </del>
                  ) : item?.marketRetail > item?.unitRetail ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.marketRetail}
                    </del>
                  ) : null}
                </div>
                <div className="product-cart">
                  <div className="product-cart2">
                    <button
                      onClick={() => {
                        // // console.log('asad2324', item)
                        dispatch(AddToCart(item));
                        toast.success("Product Added Successfully ", {
                          position: "top-center",
                          autoClose: 1000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                      }}
                    >
                      <MdShoppingCart />
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <ClipLoader color={"red"} loading={true} size={100} />
        )}
      </div>
    </>
  );
}

export default Allapiproduct;
